import { Route } from "react-router";
import { Routes } from "react-router-dom";
import { PreserveSearchNavigate } from "../../components/Navigate/PreserveSearchNavigate.tsx";
import { Query } from "../../components/Query/Query.tsx";
import { useOnMount } from "../../hooks/useOnMount.ts";
import { CREATE_WORKSPACE, EDIT_WORKSPACE } from "../../routes.ts";
import { selectedAssetUuidStore } from "../boardState/stores/selectedAssetUuidStore.ts";
import { BoardContent } from "./BoardContent.tsx";
import { useBoardUuid } from "./hooks/useBoardUuid.ts";
import { usePurchaseAndDownload } from "./hooks/usePurchaseAndDownload.ts";
import { clearShoppingCart, getShoppingCart } from "./utils/shoppingCart.ts";
import {
  useDefaultCreateTool,
  useDefaultEditTool,
} from "./Workspaces/hooks/useDefaultTool.ts";

export const BoardView = () => {
  const boardUuid = useBoardUuid();
  const defaultEditTool = useDefaultEditTool();
  const defaultCreateTool = useDefaultCreateTool();

  const defaultToolPath = selectedAssetUuidStore.getState().selectedAssetUuid
    ? `${EDIT_WORKSPACE}/${defaultEditTool}`
    : `${CREATE_WORKSPACE}/${defaultCreateTool}`;

  const shoppingCart = getShoppingCart();
  if (shoppingCart) {
    return (
      <PurchaseAndDownloadRedirect
        assetUuids={shoppingCart.assetUuids}
        contentUuids={shoppingCart.contentUuids}
      />
    );
  }

  return (
    <Query queryKey={`boards/${boardUuid}`}>
      {() => (
        <Routes>
          <Route
            path="/"
            element={<PreserveSearchNavigate replace to={defaultToolPath} />}
          />
          <Route path="*" element={<BoardContent />} />
        </Routes>
      )}
    </Query>
  );
};

const PurchaseAndDownloadRedirect = ({
  assetUuids,
  contentUuids,
}: {
  assetUuids: string[];
  contentUuids: string[];
}) => {
  const { mutate: purchaseAndDownload } = usePurchaseAndDownload({
    assetUuids,
    contentUuids,
  });
  useOnMount(() => {
    purchaseAndDownload();
    clearShoppingCart();
  });

  return <PreserveSearchNavigate to={window.location.toString()} />;
};
